<template>
  <AppLayout>
    <main
      class="flex-1 relative z-0 overflow-y-auto pt-2 pb-6 focus:outline-none md:py-6 bg-light  border-l border-primary-200"
      tabindex="0"
    >
      <div class="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
        <slot></slot>
      </div>
    </main>
  </AppLayout>
</template>

<script>
import AppLayout from "./AppLayout";
export default {
  components: { AppLayout },
};
</script>
